import React, { useState } from "react";
import { Typography, Button, Badge, Avatar, Spin, Alert } from "antd";
import { DashboardOutlined, MessageOutlined } from "@ant-design/icons";
import { useSignalR } from "Common/hooks/context/SingleRContext";
import { useNavigate } from "react-router-dom";
import useProAdminDashboard from "../Hooks/useProAdminDashboard";

const { Title, Text } = Typography;

export const ProAdminHeader = () => {
  const { unreadMessages } = useSignalR();
  const navigate = useNavigate();
  const { dashboardData, loading, error } = useProAdminDashboard();
  const admin = dashboardData?.admin;

  const [darkMode, setDarkMode] = useState(false);
  const toggleDarkMode = (checked) => setDarkMode(checked);

  

  // Show error state
  if (error) {
    return (
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
        <Alert
          message="Failed to load dashboard"
          description={error}
          type="error"
          showIcon
        />
      </div>
    );
  }

  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
      <div>
        <Title level={2} style={{ margin: 0 }}>
          <DashboardOutlined /> CoreIQPro Super Admin Dashboard
        </Title>
        <Text type="secondary">Welcome, Super Admin</Text>
      </div>

      {/* <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
        <Badge count={unreadMessages} size="small" offset={[0, 6]}>
          <Button
            type="text"
            onClick={() => navigate("/messaging")}
            icon={<MessageOutlined style={{ fontSize: 20 }} />}
            shape="circle"
          />
        </Badge>
      </div> */}
    </div>
  );
};